import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CampaignCalendarComponent = lazy(() =>
  import("@campaigns/CampaignCalendar/CampaignCalendarForNro").then((module) => ({
    default: module.CampaignCalendarForNro,
  }))
);

export const contentCalendarNRO: NavigationRoutingObject = {
  Component: CampaignCalendarComponent,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("content-calendar-sidebar-pill-menu-option", "Content Calendar"),
  pageNameForTracking: () => "Content Calendar",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "content-calendar-sidebar-pill-menu-option-description",
      "View upcoming scheduled campaigns and related analytics"
    ),
  icon: "new-nav-system-content-calendar",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroup", { permission: "viewCampaigns" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
